import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { ItemProps, PropAlignItems } from '.';
import { Colors } from '../Colors';
import {
  helperTypographyText,
  helperLinkReset,
  helperButtonReset,
  SizeType as TypographySizeType
} from '../../helpers';
import { Media } from '../../types';
import { setDeclaration } from '../../utils';
import isPropValid from '@emotion/is-prop-valid';

type CursorType = 'default' | 'pointer' | 'not-allowed';

const getCursotTabItem = (props: ItemProps): CursorType => {
  if (props.isDisabled) {
    return 'not-allowed';
  }

  if (props.isActive) {
    return 'default';
  }

  return 'pointer';
};

export const TabItem = styled('button', {
  shouldForwardProp: isPropValid
})<ItemProps>`
  ${helperLinkReset};
  ${helperButtonReset};
  position: relative;
  display: inline-block;
  margin-bottom: 0.8rem;
  font-weight: inherit;
  text-align: left;
  color: ${props => (props.isActive ? Colors.text.default : Colors.text.defaultDim)};
  cursor: ${props => getCursotTabItem(props)};

  &:after {
    content: '';
    position: absolute;
    bottom: -0.8rem;
    left: 0;
    width: ${props => (props.isActive ? '100%' : '0')};
    height: 0;
    border-bottom: 2px solid ${Colors.text.default};
    opacity: ${props => (props.isActive ? 1 : 0)};
    transform: ${props => (props.isActive ? 'scaleX(1)' : 'scaleX(0)')};
    transform-origin: 0 0;
    transition: opacity 0.3s, transform 0.3s;
  }

  ${props =>
    !props.isActive &&
    !props.isDisabled &&
    css`
      &:hover,
      &:focus {
        color: ${Colors.text.default};
      }
    `};
`;

export const TabItemWrapper = styled('div')``;

interface TabsContainerProps {
  size: TypographySizeType | Media<TypographySizeType>;
  gap?: number | Media<number>;
  alignItems?: PropAlignItems;
  caps?: boolean;
}

export const TabsContainer = styled('div')<TabsContainerProps>`
  position: relative;
  display: flex;
  align-items: ${props => props.alignItems};

  /* Если делать через border-bottom, то на разных разрешениях экранов проявляется несостыковка с линией активного таба */
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 0;
    border-bottom: 1px solid ${Colors.ut.border10};
  }

  ${TabItemWrapper} {
    ${props => helperTypographyText({ size: props.size, weight: 'bold', caps: props.caps })};
  }

  ${TabItem} + ${TabItem} {
    ${props => setDeclaration('marginLeft', props.gap, 'rem')};
  }
`;

export const Caption = styled('div')`
  margin-left: auto;
`;
